// Charge les différents modules pour la vue correspondante.

//TODO
// AJouter une 301 sur la vue et supprimer tous les fichiers impliqués

import master from 'Modules/master'
// import carousel from 'Modules/carousel'

$('#filtreCp').change(function () {
    window.location.href = '/clickcollect/boutiques/?cp=' + $('#filtreCp').val()
})
master.process() // Doit-être appelé dans toutes les vues : Contient l'appel au code du header et du footer
// carousel.process()
